import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

/**
 * Cena za 100 ml.
 *
 * Vlastni prepocet tady zamerne NENI. Cenu pocita Liquid v
 * blocks/price-per-100ml.liquid, takze je vzdy ve valute aktualniho
 * marketu a naformatovana filtrem | money. Pri zmene varianty Shopify
 * doda prerenderovane HTML v event.detail.data.html a my jen vymenime
 * obsah teto komponenty.
 */
class PricePer100 extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateUnitPrice);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateUnitPrice);
  }

  /**
   * @param {CustomEvent} event - variant:update
   */
  updateUnitPrice = (event) => {
    const detail = event.detail;
    if (!detail || !detail.data || !detail.data.html) return;

    if (detail.data.newProduct) {
      this.dataset.productId = detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    // Nejprve hledame stejny blok podle id, aby se neprepsala jina
    // instance komponenty na stejne strance.
    const newElement =
      detail.data.html.querySelector(`price-per-100[data-block-id="${this.dataset.blockId}"]`) ||
      detail.data.html.querySelector('price-per-100');

    if (!newElement) return;

    morph(this, newElement, { childrenOnly: true });
  };
}

if (!customElements.get('price-per-100')) {
  customElements.define('price-per-100', PricePer100);
}
